/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_List_BodyInputs */

const cs_viewings_list_body = /** @type {(inputs: Viewings_List_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohlídky můžete naplánovat z tohoto seznamu nebo ze záložky Prohlídky u nemovitosti.`)
};

const en_viewings_list_body = /** @type {(inputs: Viewings_List_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule viewings from this list or from a property’s Viewings tab.`)
};

/**
* | output |
* | --- |
* | "Schedule viewings from this list or from a property’s Viewings tab." |
*
* @param {Viewings_List_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_list_body = /** @type {((inputs?: Viewings_List_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_List_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_list_body(inputs)
	return cs_viewings_list_body(inputs)
});